import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Portal from "@mui/material/Portal";
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

const MobileNotifications = ({ type, message, open, handleClose }) => {
  const icons = {
    success: <CheckCircleOutlinedIcon fontSize="inherit" />,
    information: <InfoOutlinedIcon fontSize="inherit" />,
    warning: <WarningAmberOutlinedIcon fontSize="inherit" />,
    error: <ErrorOutlineOutlinedIcon fontSize="inherit" />,
  };

  const severityTypes = {
    success: "success",
    information: "info",
    warning: "warning",
    error: "error",
  };

  return (
    <Portal>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          zIndex: 4444,
          maxWidth: { xs: "calc(100% - 32px)", sm: 480 },
        }}
      >
        <Alert
          onClose={handleClose}
          severity={severityTypes[type]}
          icon={icons[type]}
          variant="filled"
          sx={{
            width: "100%",
            wordBreak: "break-word",
            ...(type === "warning" && {
              color: "black",}),
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Portal>
  );
};

export default MobileNotifications;
